import { makeStyles } from "@material-ui/core/styles";


export default makeStyles((theme) => ({

  panelContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "32px",
  },
  summeryTitle: {
    color: theme.palette.text.tertiary,
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: "24px",
  },
  summeryText: {
    color: theme.palette.text.primary,
    fontSize: "30px",
    fontWeight: 600,
  },
  aedIcon: {
    verticalAlign: "super",
    fill: theme.palette.text.tertiary,
  },
  roi: {
    color: theme.palette.text.tertiary,
    fontSize: "30px",
    fontWeight: 600,
  },
  success: {
    color: theme.palette.text.success_primary,
    fontSize: "30px",
    fontWeight: 600,
  },
  transactionList: {
    display: "flex",
    flexWrap: "wrap",
    gap: "20px",
  }
}));
